import { GlobalAxios } from "./../axios/axios-config";
import {
  INewDigitalCertificateFile,
  IDigitalCertificateFile,
} from "../models/digital-certificate-file";

const DIGITAL_CERTIFICATE_FILE_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/CompanyDigitalCertificateFile/";

export const createDigitalCertificateFile = (
  item: INewDigitalCertificateFile,
) => {
  return GlobalAxios.post(DIGITAL_CERTIFICATE_FILE_ROUTE, item);
};

export const getDigitalCertificateFileById = (id: string) => {
  return GlobalAxios.get<IDigitalCertificateFile>(
    DIGITAL_CERTIFICATE_FILE_ROUTE + id,
  );
};

export const updateDigitalCertificateFileById = ({
  item,
  id,
}: {
  item: INewDigitalCertificateFile;
  id: string;
}) => {
  return GlobalAxios.put(DIGITAL_CERTIFICATE_FILE_ROUTE + id, item);
};
